import { Scroll } from 'component/Scroll'
import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { ItemCard } from 'page/CombineScreen/item/ItemCard'
import css from 'page/CombineScreen/item/ItemsLine.module.scss'
import { Fragment } from 'react'
import { store } from 'store/store'

export const ItemsLine = observer(() => {
  const item = store.tempComboItem || store.item!
  const rec = item.rec
  const { items, index } = rec

  return (
    <Space className={css.root} tall wide top>
      <Scroll>
        <Space gap={8} wide top>
          {items.map((item, i) => (
            <Fragment key={i}>
              <ItemCard item={item} active={index === i} index={i} />
            </Fragment>
          ))}
        </Space>
      </Scroll>
    </Space>
  )
})
